import React from 'react';
import FilterBadge from './FilterBadge';
import { Box } from '@amzn/awsui-components-core';
import { ContentType } from '@amzn/awscat-pattern-library-service-model';
import { FilterType } from './FilterBadge';
import { ContentTypeSlicerId, RUMEventTracking } from '../../../monitoring';

const ContentTypeSlicer = () => {
  return (
    <div className="filter-badge-slicers">
      <Box color="text-body-secondary" margin={{ right: 's' }}>
        Content type:
      </Box>
      <RUMEventTracking id={ContentTypeSlicerId.Strategy}>
        <FilterBadge filterType={FilterType.ContentType} filterText={ContentType.Strategy} />
      </RUMEventTracking>
      <RUMEventTracking id={ContentTypeSlicerId.Guide}>
        <FilterBadge filterType={FilterType.ContentType} filterText={ContentType.Guide} />
      </RUMEventTracking>
      <RUMEventTracking id={ContentTypeSlicerId.Pattern}>
        <FilterBadge filterType={FilterType.ContentType} filterText={ContentType.Pattern} />
      </RUMEventTracking>
    </div>
  );
};

export default ContentTypeSlicer;
